'use strict';/* global define */define('modules/core/modules/utils/services/absolute-url',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["$state", "$stateParams"];
function factory($state,$stateParams){// jshint validthis:true
// jshint latedef:false
return{getUrl:getUrl};// ---
function getUrl(){return $state.href($state.current,$stateParams,{absolute:true});}}module.exports=factory;});
